import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbGlobalPosition, NbGlobalLogicalPosition } from '@nebular/theme';
import { AuthService } from './auth.service';
import { User } from '../interfaces/user.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  public user: User;

  /** Nunca se asigna en ningún lado del código actual. */
  public empresa: unknown;

  public headers: HttpHeaders;

  constructor(
    public http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private toastrService: NbToastrService
  ) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.authService.getToken());
    this.user = JSON.parse(localStorage.getItem('usuario')) || {};
  }

  /* eslint-disable @typescript-eslint/no-explicit-any --
     API genérica del backend: el payload y la forma de la respuesta cambian según
     el endpoint que la llame en cada punto de uso; no hay un tipo único posible aquí. */

  /**
   * API Generico GET
   * @param {string} api route: api/componente
   * @return {Observable<any>} respuesta asincrónica
   */
  get({ api }: { api: string }) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.authService.getToken());
    return this.http.get<any>(`${environment.baseURL}${api}`, {
      headers: this.headers,
    });
  }

  /* get2(object: String) {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json");
    this.headers.append("Authorization", this.authService.getToken());
    return this.http
      .get(this.baseUrl + "" + object, { headers: this.headers })
      .pipe(map((res) => res.json()));
  } */
  /* put2(object: String, data: any) {
     this.headers = new Headers();
     this.headers.append("Content-Type", "application/json");
     this.headers.append("Authorization", this.authService.getToken());
     return this.http
       .put(this.baseUrl + "" + object, JSON.stringify(data), {
         headers: this.headers,
       })
       .pipe(map((res) => res.json()));
   } */
  /**
   * API Generico POST
   * @param {string} api route: api/componente
   * @param {any} data objeto a persistir
   * @return {Observable<any>} respuesta asincrónica
   */
  post({ api, data }: { api: string; data: any }) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.authService.getToken());
    return this.http.post<any>(`${environment.baseURL}${api}`, JSON.stringify(data), { headers: this.headers });
  }

  /**
   * API Generico DELETE
   * @param {string} api route: api/componente/id
   * @return {Observable<any>} respuesta asincrónica
   */
  delete({ api }: { api: string }) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.authService.getToken());
    return this.http.delete<any>(`${environment.baseURL}${api}`, {
      headers: this.headers,
    });
  }

  /**
   * API Generico PUT
   * @param {string} api route: api/componente/id
   * @param {any} data propiedades a actualizar
   * @return {Observable<any>} respuesta asincrónica
   */
  put({ api, data }: { api: string; data: any }) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', this.authService.getToken());
    return this.http.put<any>(`${environment.baseURL}${api}`, JSON.stringify(data), { headers: this.headers });
  }

  /**
   * Método POST PROMISE
   * @param {string} object ruta que se ejecutara
   * @param {object} data object con info a enviar al post
   */
  postPromise(object: string, data: any) {
    return new Promise((success, fail) => {
      this.headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Authorization', this.authService.getToken());
      this.http
        .post<any>(`${environment.baseURL}${object}`, JSON.stringify(data), {
          headers: this.headers,
        })
        .subscribe(
          (result) => {
            success(result);
          },
          (err) => {
            fail(err);
          }
        );
    });
  }

  sendEmailReport(dataEmail: any) {
    // let dataEmail = {};
    /*   dataEmail = {
      to: data.email,
      from: data.email,
      nombre: data.nombre,
      subject: data.asunt,
      contenido: data.msjs,
      titulo: "",
      cc: "Prueba",
    }; */
    this.http
      .post<any>(`${environment.baseURL}enviar-correo`, dataEmail, {
        headers: this.headers,
      })
      .subscribe(() => {
        // fire-and-forget: no response handling needed for this notification email.
      });
  }

  /* eslint-enable @typescript-eslint/no-explicit-any */

  /**
   * Opens a Nebular Dialog
   * @param  {any} dialog Reference to the template
   * containing the dialog. Must be type ElementRef or TypeReference
   * @returns void
   */
  showToastr({
    position,
    title,
    message,
    status,
  }: {
    position?: NbGlobalPosition;
    title: string;
    message?: string;
    status: NbComponentStatus;
  }): void {
    const realPosition = position || NbGlobalLogicalPosition.TOP_END;
    const realMessage = message || '';
    const duractionMilisec = 4500;
    this.toastrService.show(`${realMessage}`, `${title}`, {
      position: realPosition,
      status,
      duration: duractionMilisec,
    });
  }

  /**
   * Handles navigation to the specified URL
   * @param {string} path -> "/index/home"
   * @return void
   */
  public routerNavigateTo({ path }: { path: string }): void {
    this.router.navigate([path]).then((fulfilled) => {
      if (!fulfilled) {
        this.showToastr({
          title: 'Invalid URL',
          status: 'basic',
        });
      }
    });
  }
}
